import { arrowToolConfig } from "./ArrowToolButton";
import { calloutToolConfig } from "./CalloutToolButton";
import { cloudToolConfig } from "./CloudToolButton";
import { ellipseToolConfig } from "./EllipseToolButton";
import { highlightToolConfig } from "./HighlightToolButton";
import { imageToolConfig } from "./ImageToolButton";
import { penToolConfig } from "./PenToolButton";
import { polylineToolConfig } from "./PolylineToolButton";
import { redactToolConfig } from "./RedactToolButton";
import { rectCalloutToolConfig } from "./RectCalloutToolButton";
import { rectToolConfig } from "./RectToolButton";
import { selectToolConfig } from "./SelectToolButton";
import { stampToolConfig } from "./StampToolButton";
import { textToolConfig } from "./TextToolButton";

export const TOOL_CONFIGS = {
  [selectToolConfig.id]: selectToolConfig,
  [imageToolConfig.id]: imageToolConfig,
  [penToolConfig.id]: penToolConfig,
  [arrowToolConfig.id]: arrowToolConfig,
  [rectToolConfig.id]: rectToolConfig,
  [ellipseToolConfig.id]: ellipseToolConfig,
  [cloudToolConfig.id]: cloudToolConfig,
  [textToolConfig.id]: textToolConfig,
  [calloutToolConfig.id]: calloutToolConfig,
  [rectCalloutToolConfig.id]: rectCalloutToolConfig,
  [polylineToolConfig.id]: polylineToolConfig,
  [redactToolConfig.id]: redactToolConfig,
  [highlightToolConfig.id]: highlightToolConfig,
  [stampToolConfig.id]: stampToolConfig,
};

export const DEFAULT_TOOL_ID = selectToolConfig.id;
